// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { Generation } from './Generation';
import { BEComponent } from './BEComponent';
import { BEEntity } from './BEEntity';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
import { EntityGenerationExtend } from '../../../../../../extension/com/MetaPattern/MDA/MD/EntityModel/EntityGenerationExtend';
/**
 * 实体继承关系 实体类
 * 实体继承关系
 */
export class EntityGeneration extends Generation {
  /** 组件 的ID */
  private _component_ID: string;

  /** 获取：组件 的ID */
  public get component_ID() {
    return this._component_ID;
  }

  /** 设置：组件 的ID */
  public set component_ID(value: string) {
    this._component_ID = value;
  }

  /** 组件  */
  private _component: BEComponent;

  /** 获取：组件  */
  public get component() {
    return this._component;
  }

  /** 设置：组件  */
  public set component(value: BEComponent) {
    this._component = value;
    if (value !== null) {
      this.component_ID = value.id;
    } else {
      this.component_ID = '';
    }
  }

  /** 父实体 的ID */
  private _superEntity_ID: string;

  /** 获取：父实体 的ID */
  public get superEntity_ID() {
    return this._superEntity_ID;
  }

  /** 设置：父实体 的ID */
  public set superEntity_ID(value: string) {
    this._superEntity_ID = value;
  }

  /** 父实体  */
  private _superEntity: BEEntity;

  /** 获取：父实体  */
  public get superEntity() {
    return this._superEntity;
  }

  /** 设置：父实体  */
  public set superEntity(value: BEEntity) {
    this._superEntity = value;
    if (value !== null) {
      this.superEntity_ID = value.id;
    } else {
      this.superEntity_ID = '';
    }
  }

  /** 子实体 的ID */
  private _subEntity_ID: string;

  /** 获取：子实体 的ID */
  public get subEntity_ID() {
    return this._subEntity_ID;
  }

  /** 设置：子实体 的ID */
  public set subEntity_ID(value: string) {
    this._subEntity_ID = value;
  }

  /** 子实体  */
  private _subEntity: BEEntity;

  /** 获取：子实体  */
  public get subEntity() {
    return this._subEntity;
  }

  /** 设置：子实体  */
  public set subEntity(value: BEEntity) {
    this._subEntity = value;
    if (value !== null) {
      this.subEntity_ID = value.id;
    } else {
      this.subEntity_ID = '';
    }
  }

  constructor() {
    super();
    EntityGenerationExtend.Init(this);
    this._component_ID = '';
    this._component = null;
    this._superEntity_ID = '';
    this._superEntity = null;
    this._subEntity_ID = '';
    this._subEntity = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: EntityGeneration, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.component_ID = element.component_ID;
      if (hasReference && element.component !== null) {
        this.component = element.component;
      }
      this.superEntity_ID = element.superEntity_ID;
      if (hasReference && element.superEntity !== null) {
        this.superEntity = element.superEntity;
      }
      this.subEntity_ID = element.subEntity_ID;
      if (hasReference && element.subEntity !== null) {
        this.subEntity = element.subEntity;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.component_ID = json.Component_ID;
    // if (json.Component !== null) {
    //   this.component = BEComponent.Create(json.Component);
    // }
    this.superEntity_ID = json.SuperEntity_ID;
    // if (json.SuperEntity !== null) {
    //   this.superEntity = BEEntity.Create(json.SuperEntity);
    // }
    this.subEntity_ID = json.SubEntity_ID;
    // if (json.SubEntity !== null) {
    //   this.subEntity = BEEntity.Create(json.SubEntity);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Component_ID = this.component_ID;
    json.SuperEntity_ID = this.superEntity_ID;
    json.SubEntity_ID = this.subEntity_ID;
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    return context;
  }

  static Create(json: any): EntityGeneration {
    const entityGeneration = new EntityGeneration();
    entityGeneration.Deserialize(json);
    entityGeneration.json = json;
    return entityGeneration;
  }
}
